/*
 * Basculeur de format de la page catalogue — Épices Moralès.
 *
 * Trois etats : Jolies Fioles, Recharges, Tous les formats. Les deux premiers
 * forcent une variante sur chaque carte, le troisieme rend la page a son etat
 * d'origine, ou le bouton ouvre la feuille de choix.
 *
 * Le defaut est << Tous les formats >>, decide le 2026-09-02. La page d'arrivee
 * montre donc le catalogue entier sans presupposer le format voulu ; le
 * basculeur reste une reduction volontaire, pas un etat subi. Si ce defaut
 * change, changer aussi le bouton qui porte est-actif dans
 * snippets/format-switch.liquid, sinon le mauvais onglet s'allume au chargement.
 *
 * Trois partis pris de mise en oeuvre :
 *
 * 1. Aucune requete reseau. Les cartes portent deja toutes leurs variantes,
 *    rendues par la feuille de choix de format : prix, prix barre, image et
 *    identifiant sont lisibles dans le DOM. Basculer ne fait que relire.
 *
 * 2. L'etat d'origine de chaque carte est memorise au premier basculement, pas
 *    reconstruit. Reconstruire un bloc de prix suppose de deviner le balisage du
 *    theme ; le restituer tel quel ne suppose rien.
 *
 * 3. L'etat vit sur <body>, pas dans une variable. La CSS peut s'y accrocher, et
 *    le gestionnaire de la feuille de choix sait ainsi qu'il ne doit plus
 *    s'ouvrir quand un format est impose.
 */

(function () {
  if (window.mlsBasculeFormat) return;

  var DEFAUT = 'tous';

  function cartes() {
    return document.querySelectorAll('.product-card');
  }

  /* Memorise ce qu'il faudra pouvoir rendre. Une seule fois par carte : au
     deuxieme appel, l'original serait deja celui d'un format force. */
  function memoriser(carte) {
    if (carte._fswOrigine) return carte._fswOrigine;
    var img = carte.querySelector('.product-card__image img');
    var prix = carte.querySelector('.price');
    var champ = carte.querySelector('.product-card__qa-hidden-input');
    var bouton = carte.querySelector('.product-card__quickadd-inline-submit');
    var badges = carte.querySelector('.badge__container');
    var cellule = carte.parentElement;
    /* La place d'origine se note maintenant, pas au moment de la rendre : une
       fois des cartes reléguées, l'ordre du DOM ne la donne plus. */
    if (cellule && cellule.parentElement) {
      carte._fswRang = Array.prototype.indexOf.call(cellule.parentElement.children, cellule);
    }
    carte._fswOrigine = {
      /* L'etat epuise vient du SERVEUR quand le produit entier est indisponible
         (Liquid pose product-card--epuise). Le basculeur doit le rendre tel
         qu'il l'a trouve, pas l'effacer : c'est ce qu'il faisait, et l'onglet
         « Tous les formats », qui passe par rendreOrigine, degrisait donc
         toutes les cartes epuisees du catalogue. */
      epuise: carte.classList.contains('product-card--epuise'),
      badges: badges ? badges.innerHTML : null,
      boutonDesactive: bouton ? bouton.disabled : false,
      boutonAria: bouton ? bouton.getAttribute('aria-disabled') : null,
      src: img ? img.getAttribute('src') : null,
      srcset: img ? img.getAttribute('srcset') : null,
      prix: prix ? prix.innerHTML : null,
      id: champ ? champ.value : null,
      bouton: bouton ? bouton.innerHTML : null,
      boutonFormat: bouton ? bouton.classList.contains('product-card__quickadd-inline-submit--format') : false
    };
    return carte._fswOrigine;
  }

  function rendreOrigine(carte) {
    var o = carte._fswOrigine;
    if (!o) return;
    var img = carte.querySelector('.product-card__image img');
    if (img && o.src) {
      img.setAttribute('src', o.src);
      if (o.srcset) img.setAttribute('srcset', o.srcset);
    }
    var prix = carte.querySelector('.price');
    if (prix && o.prix !== null) prix.innerHTML = o.prix;
    var champ = carte.querySelector('.product-card__qa-hidden-input');
    if (champ && o.id) champ.value = o.id;
    var bouton = carte.querySelector('.product-card__quickadd-inline-submit');
    if (bouton && o.bouton !== null) {
      bouton.innerHTML = o.bouton;
      bouton.classList.toggle('product-card__quickadd-inline-submit--format', o.boutonFormat);
      bouton.disabled = o.boutonDesactive;
      if (o.boutonAria === null) bouton.removeAttribute('aria-disabled');
      else bouton.setAttribute('aria-disabled', o.boutonAria);
    }
    var badges = carte.querySelector('.badge__container');
    if (badges && o.badges !== null) badges.innerHTML = o.badges;
    carte.classList.toggle('product-card--epuise', !!o.epuise);
    carte.removeAttribute('data-fsw-absent');
    /* Un produit epuise en entier reste relegue dans TOUS les onglets, y compris
       « Tous les formats » : la raison ne depend pas du filtre. Ce qu'on ne peut
       pas acheter ne prend pas le haut de la grille. */
    marquerEpuise(carte, !!o.epuise);
  }

  /* La carte n'est pas la cellule de la grille : son PARENT l'est, pose par
     la section (`<div class="col-sp-... grid-...">`). Masquer la seule carte
     laissait donc la cellule en place, avec sa largeur et sa hauteur : un trou
     blanc au milieu de la grille, constate sur telephone le 2026-09-22.

     On marque donc aussi la cellule, mais UNIQUEMENT si elle ne contient que
     cette carte. Le meme gabarit de carte est rendu ailleurs dans le theme
     (recommandations, tiroir du panier, collage) ou son parent porte parfois
     autre chose : sans cette garde, on masquerait ce qui l'accompagne. */
  function marquerCellule(carte, absent) {
    var cellule = carte.parentElement;
    if (!cellule || cellule.children.length !== 1) return;
    if (absent) cellule.setAttribute('data-fsw-absent', '1');
    else cellule.removeAttribute('data-fsw-absent');
  }

  /* Releguer sans deplacer le DOM.

     Le conteneur est un `display:flex; flex-wrap:wrap` (base.css), donc `order`
     suffit : la carte epuisee passe derriere toutes les autres sans qu'aucun
     noeud ne bouge. Deplacer reellement les cellules aurait oblige a memoriser
     un voisin pour les remettre, et ce voisin peut lui-meme avoir bouge.

     Pourquoi releguer plutot que laisser en place : le filtre a ete demande, il
     doit servir a quelque chose. Sur telephone une carte occupe une cellule
     pleine ; trois epuisees dispersees, et on fait defiler des cases mortes
     pour trouver ce qu'on peut acheter. Pourquoi ne pas retirer : une carte qui
     disparait ne se lit jamais « en rupture », elle se lit « ils ne le font pas
     dans ce format » — et le compteur de l'onglet se met a mentir. */
  function marquerEpuise(carte, epuise) {
    var cellule = carte.parentElement;
    if (!cellule) return;
    if (epuise) {
      cellule.style.order = 1000 + (carte._fswRang || 0);
      cellule.setAttribute('data-fsw-relegue', '1');
    } else {
      cellule.style.order = '';
      cellule.removeAttribute('data-fsw-relegue');
    }
  }

  function appliquer(carte, format) {
    memoriser(carte);
    if (format === 'tous') {
      rendreOrigine(carte);
      marquerCellule(carte, false);
      return;
    }

    var rangee = carte.querySelector('.product-card__qa-option[data-variant-format="' + format + '"]');
    /* Deux cas bien distincts, longtemps confondus.

       1. Le produit n'a PAS ce format du tout (un coffret n'existe pas en
          recharge) : la carte sort de la grille. L'afficher avec les donnees
          d'un autre format tromperait sur ce qu'on a demande.
       2. Le produit a ce format mais il est EPUISE : la carte reste, avec les
          donnees du format demande, grisee, badgee et reléguée en fin de
          grille. C'est le traitement de tout le reste de la boutique. */
    if (!rangee) {
      rendreOrigine(carte);
      carte.setAttribute('data-fsw-absent', '1');
      marquerCellule(carte, true);
      return;
    }
    carte.removeAttribute('data-fsw-absent');
    marquerCellule(carte, false);

    var epuise = rangee.classList.contains('is-unavailable');
    carte.classList.toggle('product-card--epuise', epuise);
    marquerEpuise(carte, epuise);

    var zoneBadges = carte.querySelector('.badge__container');
    if (zoneBadges) {
      if (epuise) {
        /* Le badge du theme, celui des cartes deja epuisees au rendu : meme
           classe, donc meme forme et memes couleurs, reglees au customizer. */
        zoneBadges.innerHTML = '<span class="badge badge--sold_out">'
          + (window.mlsTexteEpuise || 'Épuisé') + '</span>';
      } else if (carte._fswOrigine && carte._fswOrigine.badges !== null) {
        zoneBadges.innerHTML = carte._fswOrigine.badges;
      }
    }

    var d = rangee.dataset;

    var img = carte.querySelector('.product-card__image img');
    if (img && d.variantImg) {
      /* srcset retire : il decrit l'image d'origine et gagnerait sur src, le
         navigateur continuerait d'afficher le packshot du produit. */
      img.removeAttribute('srcset');
      img.setAttribute('src', d.variantImg);
    }

    var prix = carte.querySelector('.price');
    if (prix && d.variantPrice) {
      prix.innerHTML = '<div class="price__main-color card__price__main h5">' + d.variantPrice + '</div>' +
        (d.variantCompare ? '<div class="price__regular body2"><s>' + d.variantCompare + '</s></div>' : '');
    }

    var champ = carte.querySelector('.product-card__qa-hidden-input');
    if (champ && d.variantId) champ.value = d.variantId;

    var bouton = carte.querySelector('.product-card__quickadd-inline-submit');
    if (bouton && d.variantPrice) {
      /* Le bouton n'ouvre plus la feuille, il ajoute : le modificateur --format
         n'a plus lieu d'etre. */
      bouton.classList.remove('product-card__quickadd-inline-submit--format');

      /* On ne reecrit QUE le libelle, jamais le innerHTML du bouton.

         Le bouton contient aussi le <div.loading-overlay__spinner> pose en
         Liquid, et product-form.js fait, sans aucune garde et juste apres son
         preventDefault :

             this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

         Un innerHTML qui emporte le spinner ne coutait donc pas l'animation :
         il levait une exception avant le fetch, et l'ajout au panier ne partait
         jamais. Le bouton paraissait inerte, sans rien dans la console pour un
         visiteur.

         C'est le piege deja documente dans le CLAUDE.md de MLS pour les boutons
         de la fiche produit : tout balisage pose en Liquid dans un bouton est
         efface par le script qui reecrit son contenu. La parade est la meme,
         toucher le noeud de texte et rien d'autre. */
      var libelle = bouton.querySelector('span');
      if (libelle) {
        libelle.innerHTML = epuise
          ? (window.mlsTexteEpuise || 'Épuisé')
          : 'Ajouter&nbsp;&middot;&nbsp;' + d.variantPrice;
      }
      /* DEUX attributs, pas un. `disabled` empeche l'ajout — sans lui le bouton
         proposait une variante indisponible et le panier repondait 422 en
         silence. Mais c'est `aria-disabled` qui le GRISE : la regle du theme est
         `.btn[aria-disabled=true]` (base.css), rien n'est accroche a `disabled`.
         Le Liquid pose bien les deux ; le script n'en posait qu'un, et le bouton
         « Epuise » d'un produit encore disponible dans un autre format restait
         noir, donc d'apparence cliquable. */
      bouton.disabled = epuise;
      if (epuise) bouton.setAttribute('aria-disabled', 'true');
      else bouton.removeAttribute('aria-disabled');
    }
  }

  function basculer(format) {
    document.body.setAttribute('data-fsw-format', format);
    /* Un panneau de format laisse ouvert par un survol precedent garderait son
       attribut `open`, et une regle de component-product-card.css masque le
       bouton d'ajout tant qu'il l'a. Le panneau est invisible dans cet etat :
       le defaut se lirait comme un bouton disparu sans raison. */
    if (format !== 'tous') {
      document.querySelectorAll('.product-card__qa-dropdown[open]').forEach(function (d) {
        d.open = false;
      });
    }
    cartes().forEach(function (c) { appliquer(c, format); });
    document.querySelectorAll('[data-fsw] .fsw__b').forEach(function (b) {
      var actif = b.dataset.fswFmt === format;
      b.classList.toggle('est-actif', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
  }

  /* Remonter en tete de grille apres un changement de format.

     Sans cela, changer de format depuis la barre du bas alors qu'on est dans le
     pied de page ne montre rien : les cartes changent bel et bien, mais elles
     sont hors ecran. Le controle repond, la page ne bouge pas, et on croit qu'il
     ne marche pas. Meme geste que les pastilles de categorie, dont c'est deja le
     comportement.

     La logique appartient a la section des pastilles, qui l'expose : elle ne se
     reduit pas a un scrollTo. Il y a une sentinelle, l'en-tete du theme a
     empecher de reapparaitre par-dessus la barre, et un maintien de position
     pendant une demi-seconde contre l'elan du defilement sur mobile. La
     dupliquer aurait fait vivre deux versions d'une meme mecanique.

     Elle ne fait rien si on est deja au-dessus de la grille : cliquer dans le
     hero ne provoque donc aucun saut. */
  function remonterEnTete() {
    if (typeof window.mlsRemonterGrille === 'function') {
      window.mlsRemonterGrille();
      return;
    }
    /* Repli si la section des pastilles n'est pas sur la page. */
    var grille = document.getElementById('ProductGridContainer');
    if (!grille) return;
    var cible = grille.getBoundingClientRect().top + window.pageYOffset;
    if (window.pageYOffset > cible) window.scrollTo(0, cible);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fsw] .fsw__b');
    if (!b) return;
    e.preventDefault();
    /* Avant le basculement : la grille peut raccourcir quand des cartes
       s'effacent, et la hauteur du document changerait sous nos pieds. */
    remonterEnTete();
    basculer(b.dataset.fswFmt);
  });

  /* La grille est remplacee par au moins deux mecanismes : les pastilles de
     categorie et les facettes du theme, qui ecrivent tous deux dans
     #ProductGridContainer.innerHTML. Les cartes qui en sortent n'ont jamais vu
     le format demande, alors que le basculeur, lui, vit hors de la grille et
     garde son etat : on se retrouvait avec « Recharges » allume et tous les
     formats affiches.

     On observe donc le conteneur plutot que de se brancher sur chacun de ces
     mecanismes. Ce qui compte est qu'il soit arrive de nouvelles cartes, pas
     qui les a mises la : un troisieme chemin de rendu ajoute plus tard sera
     couvert sans qu'on y pense.

     Deux precautions de cout, apprises en mesurant le ralentissement du premier
     jet :

     - `childList` SANS `subtree`. Les deux mecanismes remplacent l'innerHTML du
       conteneur lui-meme, une seule mutation de ses enfants directs suffit donc
       a tout savoir. Avec `subtree`, le navigateur produisait un enregistrement
       par noeud du sous-arbre remplace, soit des centaines par changement de
       categorie, et rappelait le callback autant de fois.
     - Un seul passage groupe par image, via requestAnimationFrame. Les
       enregistrements arrivent en rafale ; sans ce groupage on relisait tout le
       DOM a chaque rafale.

     Pas de garde anti-boucle explicite : on ne retouche que les cartes sans
     _fswOrigine, donc jamais celles qu'on vient d'ecrire. Le tour suivant, que
     nos propres mutations declenchent, ne trouve plus rien a faire et s'arrete. */
  function surveillerLaGrille() {
    var hote = document.getElementById('ProductGridContainer');
    if (!hote || !window.MutationObserver) return;
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () {
        prevu = false;
        var fmt = document.body.getAttribute('data-fsw-format');
        if (!fmt || fmt === 'tous') return;
        cartes().forEach(function (c) {
          if (!c._fswOrigine) appliquer(c, fmt);
        });
      });
    }).observe(hote, { childList: true });
  }

  /* La barre du bas est rendue dans le hero, pour n'exister que la ou le
     basculeur existe. Mais un element `position: fixed` ne depend pas que de
     lui-meme : il suffit qu'un seul de ses ancetres porte un `transform`, un
     `filter` ou un `contain` pour qu'il se recadre sur cet ancetre au lieu de
     l'ecran. Plutot que d'auditer les huit ancetres du hero et d'esperer que
     personne n'en ajoute un neuvieme, on supprime la dependance : la barre passe
     sous <body>. Meme parade que la feuille de format des cartes produit.

     Elle parait quand le basculeur du hero sort de l'ecran, et disparait quand
     il revient : deux exemplaires du meme controle visibles en meme temps se
     liraient comme deux controles differents. */
  function poserLaBarre() {
    var barre = document.querySelector('[data-fsw-barre]');
    var hero = document.querySelector('.fsw-hote [data-fsw]');
    if (!barre) return;
    if (barre.parentNode !== document.body) document.body.appendChild(barre);
    if (!hero || !window.IntersectionObserver) {
      /* Sans repere ni observateur, mieux vaut la barre toujours visible qu'un
         controle jamais atteignable une fois la page defilee. */
      barre.classList.add('est-visible');
      return;
    }
    new IntersectionObserver(function (entrees) {
      barre.classList.toggle('est-visible', !entrees[0].isIntersecting);
    }).observe(hero);
  }

  function demarrer() {
    if (!document.querySelector('[data-fsw]')) return;
    basculer(DEFAUT);
    surveillerLaGrille();
    poserLaBarre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  window.mlsBasculeFormat = { basculer: basculer };
})();
